var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:_vm.classes},[_c('TheAppHeader',{ref:"header",attrs:{"show-menu":_vm.showMenu}}),_c('div',{staticClass:"page-content"},[_vm._t("default")],2),(_vm.showFooter)?_c('TheAppFooter'):(_vm.showFalseFooter)?_c('div',{staticClass:"false-footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }